<template>
  <div class="mt-1 d-flex full-width">
    <div
      v-if="!hideLabel"
      class="label-name mb-1 flex-grow-0"
      style="color: #000;font-size:16px"
    >
      <label for="">
        {{ label }}
      </label>
    </div>
    <v-menu
      close-on-click
      :close-on-content-click="false"
      :disabled="readonly"
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          :color="color"
          depressed
          v-on="on"
          style="border: 1px solid #4D5656"
        >
        </v-btn>
      </template>
      <v-color-picker
        v-if="!readonly"
        v-model="color"
        class="flex-grow-0"
        :mode="mode"
        show-swatches
        @input="input"
      ></v-color-picker>
    </v-menu>
    <div v-if="$slots['append']" class="pa-2 flex-grow-1">
      <slot name="append" />
    </div>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  props: {
    label: { type: String, default: ' Màu hiển thị' },
    value: { type: String },
    hideLabel: Boolean,
    readonly: Boolean,
    mode: {
      type: String,
      default: 'hexa',
    },
  },
  data: () => ({ color: '#000000', menu: false }),
  watch: {
    value: {
      handler(value) {
        this.color = this.toHex6(value)
      },
      immediate: true,
    },
  },
  methods: {
    toHex6(value) {
      if (!value || typeof value !== 'string') return '#000000'
      const color = value.trim()
      if (/^#[0-9a-fA-F]{8}$/.test(color)) return color.slice(0, 7).toUpperCase()
      if (/^#[0-9a-fA-F]{6}$/.test(color)) return color.toUpperCase()
      if (/^#[0-9a-fA-F]{3}$/.test(color)) {
        return (
          '#' +
          color[1] +
          color[1] +
          color[2] +
          color[2] +
          color[3] +
          color[3]
        ).toUpperCase()
      }
      return color
    },
    input(e) {
      this.$emit('input', this.toHex6(e))
    },
  },
}
</script>
